import React from "react";
import { SingleMaterialContentWrapper } from "../../single/Styled";
import { MaterialOrder, MaterialImport } from "../../../../data/entities";
import { MissingMaterialList } from "./MissingMaterialList";

interface ImportMaterialTabProps {
    materialOrder: MaterialOrder;
    mergeMaterialOrder: Function;
    materialImports: MaterialImport[];
}

export const ImportMaterialTab = ({
    materialOrder,
    mergeMaterialOrder,
    materialImports,
}: ImportMaterialTabProps) => {
    return (
        <SingleMaterialContentWrapper>
            <MissingMaterialList
                materialOrder={materialOrder}
                mergeMaterialOrder={mergeMaterialOrder}
                materialImports={materialImports}
            />
        </SingleMaterialContentWrapper>
    );
};
